import type { SVGProps } from "react";

export const UnderstandingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42" fill="none" {...props}>
    <g clipPath="url(#clip0_42_1475)">
      <path
        d="M20.1598 21V25.2C20.1598 25.83 19.8406 26.3844 19.3198 26.6784C18.799 26.9724 18.1438 26.9472 17.6146 26.6196C16.783 26.0988 16.1698 25.956 15.5062 26.0904C14.5318 26.292 13.7002 27.048 13.4986 28.0224C13.1542 29.652 14.3974 31.0884 15.9598 31.0884C16.4638 31.0884 16.9678 30.912 17.6062 30.5088C18.1354 30.1812 18.7906 30.156 19.3114 30.45C19.8406 30.744 20.1514 31.2984 20.1514 31.9284V36.1284"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinejoin="round"
      />
      <path
        d="M20.1597 21V16.8C20.1597 16.17 20.4789 15.6156 20.9997 15.3216C21.5205 15.0276 22.1757 15.0528 22.7049 15.3804C23.3433 15.7752 23.8557 15.96 24.3513 15.96C25.9221 15.96 27.1569 14.5236 26.8125 12.894C26.6109 11.9196 25.7793 11.1636 24.8049 10.962C24.1413 10.8276 23.5365 10.9704 22.6965 11.4912C22.1673 11.8188 21.5121 11.844 20.9913 11.55C20.4621 11.256 20.1513 10.7016 20.1513 10.0716V5.03162"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinejoin="round"
      />
      <path
        d="M37.7997 21H31.0797C30.4497 21 29.8953 21.3192 29.6013 21.84C29.3073 22.3608 29.3325 23.016 29.6601 23.5452C30.0549 24.1836 30.2397 24.696 30.2397 25.1916C30.2397 26.7624 28.8033 27.9972 27.1737 27.6528C26.1993 27.4512 25.4433 26.6196 25.2417 25.6452C25.1073 24.9816 25.2501 24.3768 25.7709 23.5368C26.0985 23.0076 26.1237 22.3524 25.8297 21.8316C25.5357 21.3024 24.9813 20.9916 24.3513 20.9916H20.1513"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinejoin="round"
      />
      <path
        d="M2.51971 21H9.23971C9.86971 21 10.4241 20.6808 10.7181 20.16C11.0121 19.6392 10.9869 18.984 10.6593 18.4548C10.2645 17.8164 10.0797 17.304 10.0797 16.8084C10.0797 15.2376 11.5161 14.0028 13.1457 14.3472C14.1201 14.5488 14.8761 15.3804 15.0777 16.3548C15.2121 17.0184 15.0693 17.6232 14.5485 18.4632C14.2209 18.9924 14.1957 19.6476 14.4897 20.1684C14.7837 20.6976 15.3381 21.0084 15.9681 21.0084H20.1681"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinejoin="round"
      />
      <path
        d="M35.2803 13.4401C37.5987 13.4401 39.4803 15.3217 39.4803 17.6401C39.4803 19.0093 38.8251 20.2357 37.8003 21.0001H37.7751C38.7999 21.7645 39.4803 22.9825 39.4803 24.3601C39.4803 25.8553 38.6907 27.1573 37.5147 27.9049"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1599 36.12C20.1599 38.9004 22.4195 41.16 25.1999 41.16C27.9803 41.16 30.2399 38.9004 30.2399 36.12C30.2399 35.2044 29.9879 34.3392 29.5595 33.6"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.5998 33.6C35.9182 33.6 37.7998 31.7184 37.7998 29.4C37.7998 28.0308 37.1362 26.8296 36.1198 26.0568"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.5347 4.56117C28.2995 2.46957 26.5187 0.839966 24.3599 0.839966C22.0415 0.839966 20.1599 2.72157 20.1599 5.03997"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5229 14.0952C37.6993 13.6332 37.8001 13.1292 37.8001 12.6C37.8001 10.5672 36.3553 8.87035 34.4317 8.48395C34.4317 8.45875 34.4401 8.42515 34.4401 8.39995C34.4401 6.08155 32.5585 4.19995 30.2401 4.19995C28.5181 4.19995 27.0397 5.24155 26.3929 6.71995"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4399 33.516C34.4399 33.516 34.4399 33.5748 34.4399 33.6C34.4399 35.9184 32.5583 37.8 30.2399 37.8C30.1475 37.8 30.0467 37.8 29.9543 37.7916"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.04021 13.4401C2.72181 13.4401 0.84021 15.3217 0.84021 17.6401C0.84021 19.0093 1.49541 20.2357 2.52021 21.0001H2.54541C1.52061 21.7645 0.84021 22.9825 0.84021 24.3601C0.84021 25.8553 1.62981 27.1573 2.80581 27.9049"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1599 36.12C20.1599 38.9004 17.9003 41.16 15.1199 41.16C12.3395 41.16 10.0799 38.9004 10.0799 36.12C10.0799 35.2044 10.3319 34.3392 10.7603 33.6"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.71971 33.6C4.40131 33.6 2.51971 31.7184 2.51971 29.4C2.51971 28.0308 3.18331 26.8296 4.19971 26.0568"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.785 4.56117C12.0202 2.46957 13.801 0.839966 15.9598 0.839966C18.2782 0.839966 20.1598 2.72157 20.1598 5.03997"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.79691 14.0952C2.62051 13.6332 2.51971 13.1292 2.51971 12.6C2.51971 10.5672 3.96451 8.87035 5.88811 8.48395C5.88811 8.45875 5.87971 8.42515 5.87971 8.39995C5.87971 6.08155 7.76131 4.19995 10.0797 4.19995C11.8017 4.19995 13.2801 5.24155 13.9269 6.71995"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.88019 33.516C5.88019 33.516 5.88019 33.5748 5.88019 33.6C5.88019 35.9184 7.76179 37.8 10.0802 37.8C10.1726 37.8 10.2734 37.8 10.3658 37.7916"
        stroke="currentColor"
        strokeWidth="1.68"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_42_1475">
        <rect width="40.32" height="42" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
